/**
 * @file
 * Scripts for /events page.
 */

function getResolvedDate(rawDate) {
  const date = rawDate.split('-');
  return `${date[1]}/${date[2]}/${date[0]}`;
}

function setFormDates(dateFrom, dateTo) {
  $('#edit-event-from').val(dateFrom);
  $('#edit-event-to').val(dateTo);
  $('#edit-submit-events').click();
}

function getDayOfMonth(dateFrom = true) {
  const $month = $('.fc-day-top').not('.fc-other-month');
  return dateFrom
    ? getResolvedDate($month[0].dataset.date).toString()
    : getResolvedDate($month[$month.length - 1].dataset.date).toString() + ' 23:59';
}

const $context = $('.view-event-listing', context);

$(window).on('load', () => {
  $context.once('event-calendar').each(() => {
    const $calendar = $context.find('#calendar');
    const $moveButtons = $calendar.find('.fc-button');

    const firstDayOfMonth = getDayOfMonth();
    const lastDayOfMonth = getDayOfMonth(false);
    setFormDates(firstDayOfMonth, lastDayOfMonth);

    $moveButtons.click(e => {
      e.preventDefault();
      const firstDayOfMonth = getDayOfMonth();
      const lastDayOfMonth = getDayOfMonth(false);

      setFormDates(firstDayOfMonth, lastDayOfMonth);
    });
  });
});
